import { API } from 'api'
import { all, fork } from 'redux-saga/effects'

import RecipientsUploadSaga from './RecipientsUploadSaga'

export default function* dashboardSagas() {
  yield all([fork(new RecipientsUploadSaga(API).supervise)])
}
